<template>
    <div class="tc-orange-button"
         @click.stop="$emit('click')"
         :style="{'width': width}">
        {{text}}
    </div>
</template>

<script>
export default {
    name: 'OrangeButtonOfLawlessness',
    props: [
        'text',
        'width',
    ],
    emits: [
        'click',
    ],
};
</script>

<style scoped lang="scss">
.tc-orange-button {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    color: #ffffff;
    background-color: #F58214;
    //border: 1px solid currentColor;
    padding: 0 15px;
    transition: 0.3s ease all;
}

.tc-orange-button:active {
    background-color: #e77914;
}

.tc-orange-button:hover::after {
    right: 0;
    opacity: .45;
}

.tc-orange-button::after {
    content: '';
    display: block;
    position: absolute;
    top: -2px;
    height: calc(100% + 4px);
    background-size: cover;
    opacity: 0;
    right: 100%;
    transition: .6s;
    z-index: 0;
    transform: skewX(-35deg);
    width: 40px;
    transform-origin: right top;
    background: linear-gradient(241deg,#fff 0,rgba(128,128,128,.1) 100%);
}


</style>
